import { Injectable } from '@angular/core';

import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { filterAllTruthyInTuple } from 'core/rx-js';
import { BehaviorSubject, Subject, combineLatest, debounceTime, distinctUntilChanged, map, skip, startWith, switchMap } from 'rxjs';
import { PdfViewerService } from '../../pdf-viewer.service';
import { IPdfDocumentInput } from '../../types';
import { PdfDocumentViewportsContainerService } from '../pdf-document-viewports-container/pdf-document-viewports-container.service';


@Injectable()
export class PdfDocumentViewportService {

  private readonly _destroy = new Subject<void>();

  //todo solve better

  readonly virtualViewportSubject = new BehaviorSubject<CdkVirtualScrollViewport>(undefined)
  readonly pdfDocumentSubject = new BehaviorSubject<IPdfDocumentInput>(undefined);

  readonly pdfPageInfosSubject = this._pdfViewerService.pdfPageInfosSubject

  readonly docPageProxiesObs = combineLatest([
    this.pdfDocumentSubject,
    this.pdfPageInfosSubject
  ])
    .pipe(
      filterAllTruthyInTuple(),
      map(([document, pdfPageInfos]) => pdfPageInfos.filter(({ docId }) => docId === document.id)),
    )


  readonly virtualViewportInitializedSubject = new BehaviorSubject<boolean>(false)

  readonly selectedPageSubject = this._pdfViewerService.selectedPageSubject;
  readonly selectedZoomSubject = this._pdfViewerService.selectedZoomSubject;

  readonly pdfDocumentViewportHeights = this._pdfDocumentViewportsContainerService.pdfDocumentViewportHeights

  readonly pageOverlayStyleSubject = this._pdfDocumentViewportsContainerService.pageOverlayStyleSubject;


  readonly renderedRangeObs = combineLatest([
    this.virtualViewportSubject,
    this.pdfDocumentSubject
  ])
    .pipe(
      filterAllTruthyInTuple(),
      switchMap(([virtualViewport]) =>
        virtualViewport.renderedRangeStream
          .pipe(
            startWith(virtualViewport.getRenderedRange()),
            distinctUntilChanged(({ end: prevEnd, start: prevStart }, { start, end }) => prevEnd === end && prevStart === start),
            map(({ end, start }) => ({ start: start || 0, end })),
            debounceTime(50),
          )
      )
    )

  readonly scrollIndexObs = combineLatest([
    this.virtualViewportSubject,
    this.pdfDocumentSubject
  ])
    .pipe(
      filterAllTruthyInTuple(),
      switchMap(([virtualViewport, pdfDocument]) =>
        virtualViewport.scrolledIndexChange
          .pipe(
            debounceTime(50),
            skip(1)
          )
      )
    )


  constructor(
    private _pdfViewerService: PdfViewerService,
    private _pdfDocumentViewportsContainerService: PdfDocumentViewportsContainerService
  ) {



  }

  dispose() {


  }

  ngOnDestroy() {
    this._destroy.next();
    this._destroy.complete();
  }
}
